import React, { Component } from 'react';
import StabSearchBox from '../StabSearchBox';
import ReactSearchBox from '../ReactSearchBox';
import { evaluateExperimentAndLog } from '@homeaway/abacus-client-utils';
import PropTypes from 'prop-types';

const EXPERIMENT_NAME = 'HA_PTA_HP_HomePageReactSearchBox';

class SearchBox extends Component {
  componentDidMount() {
    evaluateExperimentAndLog(EXPERIMENT_NAME);
  }

  render() {
    return this.props.showStabSearchbox ? <StabSearchBox /> : <ReactSearchBox />;
  }
}

SearchBox.propTypes = {
  showStabSearchbox: PropTypes.bool.isRequired
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/universal/components/SearchBox/SearchBox.js